import { entityFactory } from "../../../core/helpers/entity-factory";
import { UUID } from "angular2-uuid";
import { FileChangeQItem } from "../../../core/services/sync-up/file-item";
import { ReportLayoutChangeQItem } from "../../../core/services/sync-up/report-layout-item";
import { ChangeQItem } from "../../../core/services/sync-up/item";
import { isDefined } from "ionic-angular/util/util";
import { DtoHelper } from "../../../core/store/dto/dto-helper";
import { isEntitySubResource } from "../../../core/util/utils";
import { File } from '../file/file.model';

export class SyncUpItemHelper {

    /**
     * Compares itemNew to the itemOld and determines if a change has actually happened. If a
     * change is determined returns ChangeQItem otherwise undefined.
     * @param entity
     * @param userId
     * @param itemNew
     * @param itemOld
     * @returns {ChangeQItem}
     */
    static getChangeItem(entity: string, userId: string, itemNew: any, itemOld: any): ChangeQItem {

        let data: any;
        let method: string;
        let id: string;
        let version: number;
        let account: string;
        let parentId: string;

        switch (true) {
            case !isDefined(itemNew) && isDefined(itemOld): {
                method = "DELETE";
                id = itemOld.id;
                version = undefined;
                account = entity === "account" ? itemOld.id : itemOld.account;
                break;
            }
            case isDefined(itemNew) && !isDefined(itemOld) : {
                method = "POST";
                id = itemNew.id;

                itemOld = entityFactory(entity);

                const dto = DtoHelper.getDtoFromEntity(entity, itemOld);

                data = dto.initialise(itemNew).getRequestBody();

                if (!Object.keys(data).length) {
                    console.error("trying to POST an empty object of type %s. itemNew:", entity, itemNew);
                    throw new Error("cannot post an empty object");
                }

                version = undefined;
                account = entity === "account" ? itemNew.id : itemNew.account;
                break;
            }
            case isDefined(itemNew) && isDefined(itemOld): {
                method = "PATCH";
                id = itemNew.id;
                version = itemOld.version;

                const itemOldDto = DtoHelper.getDtoFromEntity(entity, itemOld);

                data = itemOldDto.apply(itemNew).getRequestBody();

                const propertiesThatChanged = Object.keys(data);

                if (propertiesThatChanged.length === 0) {
                    return undefined;
                } else if (propertiesThatChanged.length === 1 && propertiesThatChanged[0] === "modified") {
                    return undefined;
                }

                account = entity === "account" ? itemNew.id : itemNew.account;
                break;
            }
            default: {
                // noop
                // we are trying to delete an item that hasn't been pushed to persisted yet - so we don't need to do anything here
                return;
            }
        }

        if (isEntitySubResource(entity)) {
            try {
                parentId = isDefined(itemNew) ? itemNew.job : itemOld.job;
            } catch (e) {
                console.error(e, itemNew, itemOld);
                return;
            }

        }

        // the acl field should never be sent to the server
        if (data && isDefined(data[ "acl" ])) {
            delete data[ "acl" ];
        }

        if (entity === "file") {
            const itemNewSafe: File = itemNew || {};
            return new FileChangeQItem({
                key: UUID.UUID(),
                id,
                method,
                data,
                version,
                entity,
                user: userId,
                account,
                parentId,
                created: new Date(),
                fileSize: itemNewSafe.fileSize,
                localFileSystemPath: itemNewSafe.localFileSystemPath,
                name: itemNewSafe.name,
                mimeType: itemNewSafe.mimeType
            });
        }

        if (entity === "reportLayout" && (method === "POST" || method === "PATCH")) {
            return new ReportLayoutChangeQItem({
                key: UUID.UUID(),
                id,
                method,
                data,
                version,
                entity,
                user: userId,
                account,
                parentId,
                created: new Date()
            });
        }

        return new ChangeQItem({
            key: UUID.UUID(),
            id,
            method,
            data,
            version,
            entity,
            user: userId,
            account,
            parentId,
            created: new Date()
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.helper.ts